import { PropsWithChildren, useEffect } from "react";
// @ts-ignore
import { AppRegistry } from "react-native-web";

interface Props extends PropsWithChildren {}

export const StyleRegistryProvider = ({ children }: Props) => {
	useEffect(() => {
		// Register the app component for React Native Web
		AppRegistry.registerComponent("Main", () => "main");
	}, []);

	return <>{children}</>;
};
